export default async function GetPurchaseOrder(id = 0, projectId = 0) {
    let url = "";
    if (id === 0 && projectId === 0) {
        url = window.RealestateService + `/api/PurchaseOrder/GetPurchaseOrder`;
    }
    else {
        url = window.RealestateService + `/api/PurchaseOrder/GetPurchaseOrder?id=${id}&projectId=${projectId}`
    }
    let head = {
        "content-type": "application/json",
        "accept": "*/*",
        "Authorization": window.token
    }
    let response = await fetch(url, {
        method: "GET",
        headers: head,
        // body:JSON.stringify(sendForm)
    }).then(res => res.json()).catch(res => res)

    return response
}